import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

function Complaints() {
  const { user } = useAuth();
  const [complaints, setComplaints] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ booking_ref: '', customer_name: '', description: '' });
  const [files, setFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadComplaints(); }, []);

  const loadComplaints = async () => {
    setLoading(true);
    const data = await api.request('complaints.php?action=list');
    if (data?.complaints) setComplaints(data.complaints);
    setLoading(false);
  };

  const handleSubmit = async () => {
    if (!form.description.trim()) return;
    setSubmitting(true);

    const formData = new FormData();
    formData.append('booking_ref', form.booking_ref);
    formData.append('customer_name', form.customer_name);
    formData.append('description', form.description);
    formData.append('date', new Date().toISOString().split('T')[0]);

    for (let i = 0; i < files.length; i++) {
      formData.append('files[]', files[i]);
    }

    await api.request('complaints.php?action=add', {
      method: 'POST',
      body: formData
    });

    setForm({ booking_ref: '', customer_name: '', description: '' });
    setFiles([]);
    setShowForm(false);
    setSubmitting(false);
    loadComplaints();
  };

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer?')) return;
    await api.request(`complaints.php?action=delete&id=${id}`, { method: 'DELETE' });
    loadComplaints();
  };

  return (
    <div className="animate-in">
      {/* Add Complaint Button */}
      <button onClick={() => setShowForm(!showForm)} style={{
        width: '100%', padding: '14px', background: '#E53E3E', color: 'white',
        border: 'none', borderRadius: '12px', fontWeight: 600, fontSize: '14px',
        cursor: 'pointer', marginBottom: '16px'
      }}>
        {showForm ? '✕ Annuler' : '🚨 Signaler un incident'}
      </button>

      {/* Form */}
      {showForm && (
        <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '16px', marginBottom: '16px', border: '1px solid #333' }}>
          <input value={form.booking_ref} onChange={e => setForm({...form, booking_ref: e.target.value})}
            placeholder="Référence réservation (optionnel)" style={inputStyle} />
          <input value={form.customer_name} onChange={e => setForm({...form, customer_name: e.target.value})}
            placeholder="Nom du client" style={{...inputStyle, marginTop: '8px'}} />
          <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})}
            placeholder="Description de l'incident..." rows={4}
            style={{...inputStyle, marginTop: '8px', resize: 'vertical', minHeight: '100px'}} />

          {/* File Upload */}
          <div style={{ marginTop: '10px' }}>
            <label style={{
              display: 'block', padding: '12px', background: '#2a2a2a', border: '2px dashed #444',
              borderRadius: '10px', textAlign: 'center', cursor: 'pointer', fontSize: '13px', color: '#aaa'
            }}>
              📷 Ajouter photos / vidéos
              <input type="file" multiple accept="image/*,video/*" onChange={handleFileChange}
                style={{ display: 'none' }} />
            </label>
            {files.length > 0 && (
              <div style={{ marginTop: '8px', fontSize: '12px', color: '#10B981' }}>
                ✓ {files.length} fichier(s) sélectionné(s)
                <div style={{ marginTop: '4px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {files.map((f, i) => (
                    <span key={i} style={{ background: '#2a2a2a', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', color: '#888' }}>
                      {f.name.length > 20 ? f.name.substring(0, 17) + '...' : f.name}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          <button onClick={handleSubmit} disabled={submitting} style={{
            width: '100%', marginTop: '12px', padding: '12px',
            background: submitting ? '#555' : '#10B981',
            color: 'white', border: 'none', borderRadius: '10px', fontWeight: 600, cursor: 'pointer'
          }}>
            {submitting ? 'Envoi en cours...' : 'Enregistrer l\'incident'}
          </button>
        </div>
      )}

      {/* List */}
      <h3 style={{ fontWeight: 700, fontSize: '15px', marginBottom: '10px' }}>Historique des incidents</h3>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}><div className="spinner" style={{ margin: '0 auto' }}></div></div>
      ) : complaints.length === 0 ? (
        <div style={{ background: '#1a1a1a', borderRadius: '12px', padding: '20px', textAlign: 'center', border: '1px solid #333', color: '#555' }}>
          Aucun incident signalé
        </div>
      ) : (
        complaints.map(c => (
          <div key={c.id} style={{ background: '#1a1a1a', borderRadius: '12px', padding: '14px', marginBottom: '8px', border: '1px solid #333' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
              <div>
                <div style={{ fontSize: '13px', fontWeight: 600 }}>{c.customer_name || 'Client'}</div>
                <div style={{ fontSize: '11px', color: '#888' }}>{c.date} · {c.guide_name} {c.booking_ref && `· ${c.booking_ref}`}</div>
              </div>
              {user.role === 'admin' && (
                <button onClick={() => handleDelete(c.id)} style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer' }}>✕</button>
              )}
            </div>
            <p style={{ fontSize: '12px', color: '#ccc', marginTop: '8px', lineHeight: '1.5' }}>{c.description}</p>
            {c.files && c.files.length > 0 && (
              <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                {c.files.map((file, i) => (
                  <a key={i} href={file.url} target="_blank" rel="noreferrer" style={{
                    display: 'inline-block', background: '#2a2a2a', borderRadius: '8px',
                    padding: '4px 8px', fontSize: '11px', color: '#60A5FA', textDecoration: 'none'
                  }}>
                    {file.type?.startsWith('video') ? '🎥' : '📷'} {file.name || `Fichier ${i + 1}`}
                  </a>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

const inputStyle = {
  width: '100%', padding: '10px 14px', background: '#2a2a2a',
  border: '1px solid #444', borderRadius: '10px', color: 'white',
  fontSize: '13px', outline: 'none'
};

export default Complaints;
